export const LEFT_VARIANT= 'left'
export const RIGHT_VARIANT= 'right'

